
var ButtonPushBounceAnim = require("clover/panel/component/common/uiButtonAnims/PushBounceAnim")
var ButtonPushBounceIdleBubbleAnim = require("clover/panel/component/common/uiButtonAnims/PushBounceIdleBubbleAnim")
var GetRewardsPanel = xClass("GetRewardsPanel", BasePanel, function (continueCheckName, rewardsList, openPanelCb, getBySelf) {
    if (getBySelf){
        return cc.CSLoader.createNode("cocos/panel_pvp_reward_frame_getfree2.csb")
    }else{
        return cc.CSLoader.createNode("cocos/frame_getfree_frame_getfree.csb")
    }
})

GetRewardsPanel.show = function(continueCheckName, rewardsList, needLoadRes = true, openPanelCb, getBySelf = false, params = {}){
    cc.log("continueCheckName", continueCheckName, "rewardsList", rewardsList);
    var loadPanelSuccess = function(){
        GetRewardsPanel.create(continueCheckName, rewardsList, openPanelCb, getBySelf, params);
    }
    if (needLoadRes){
        var res = null;
        if (getBySelf){
            res = ["packed/PvpRewardPanelRes.pack"];
        }else{
            res = ["packed/CommonGetRewardPanelRes.pack"];
        }
        preloadWithLoading(res, loadPanelSuccess, function () {
            Toast.make(getText("error.tip.load_res_error"));
        }, function () {
            Toast.make(getText("error.tip.load_canceled"));
        });
    }else{
        loadPanelSuccess();
    }
}

GetRewardsPanel.prototype.ctor = function (continueCheckName, rewardsList, openPanelCb, getBySelf, params) {
    var self = this;
    self.getBySelf = getBySelf;
    self.params = params;
    BasePanel.prototype.init.call(self);
    self.continueCheckName = continueCheckName;
    self.rewardsList = rewardsList;
    ContinueCheckManager.getInstance().pause();
    self.showOneReward(getBySelf);
    self.finish = false;
    self.popup(true);
    if(openPanelCb){
        openPanelCb();
    }
}

GetRewardsPanel.prototype.okClick = function(){
    var self = this;
    var showNextInterval = 0;
    if (self.continueCheckName == ContinueCheckName.kShareReward){
        UserProp.getInstance().rewardProp(self.itemId, self.itemNum, null, null, ModuleName.WX_HAPPYCOINSHORT_SHARE);
        var pos = self.convertToWorldSpace(cc.p(self.coin.getPosition()));
        var flyItemOps = table();
        table.insert(flyItemOps, table(
            [1, "itemId", self.itemId],
            [1, "num", self.itemNum],
            [1, "pos", pos],
            [1, "scale", 0.5]
        ));
        HomeSceneAnimation.playGetPropAnimation(flyItemOps, null, 0.15);
    } else if (self.continueCheckName == ContinueCheckName.kCoinNotEnoughShare) {
        UserProp.getInstance().rewardProp(self.itemId, self.itemNum, null, null, ModuleName.WX_COINSHORT_SHARE);
        var pos = self.convertToWorldSpace(cc.p(self.coin.getPosition()));
        var flyItemOps = table();
        table.insert(flyItemOps, table(
            [1, "itemId", self.itemId],
            [1, "num", self.itemNum],
            [1, "pos", pos],
            [1, "scale", 0.5]
        ));
        HomeSceneAnimation.playGetPropAnimation(flyItemOps, null, 0.15);

        DCAssist.userTrack("stage_start", "share_getcoins_success");
    } else if (self.continueCheckName == ContinueCheckName.kFriendPvp) {
        UserProp.getInstance().rewardProp(self.itemId, self.itemNum, null, null, ModuleName.FRIEND_PVP);
        var pos = self.convertToWorldSpace(cc.p(self.coin.getPosition()));
        if (self.flyToPos){
            showNextInterval = 0.5;
            // pvp奖杯动画不是统一的飞到背包
            var scene = cc.Director.getInstance().getRunningScene()
            if (!scene) {
                return 
            }
            var animationLayer = cc.Layer.create();
            scene.addChild(animationLayer, 1100);
            var itemId = self.itemId;
            if (itemId == 34){
                itemId = 10100;
            }
            let icon = UIItemBuilder.createProp(itemId, self.itemNum)[0];
            icon.setPosition(pos);
            icon.setScale(1);
            animationLayer.addChild(icon);
            var clearAnim = function(){
                animationLayer.removeFromParent(true);
                self.mainPanelScoreTxtShowanim();
            }
            icon.runAction(cc.sequence(cc.EaseOut.create(cc.moveTo(0.35, self.flyToPos), 0.5), cc.callFunc(clearAnim)));
        }else{
            var flyItemOps = table();
            table.insert(flyItemOps, table(
                [1, "itemId", self.itemId],
                [1, "num", self.itemNum],
                [1, "pos", pos],
                [1, "scale", 0.5]
            ));
            HomeSceneAnimation.playGetPropAnimation(flyItemOps, null, 0.15);
        }
    } else if (self.continueCheckName == ContinueCheckName.kStarDrawReward) {
        self.notHideBannerOnClose();
        var moduleName = null;
        if (self.params && self.params.drawStatus == 1){
            moduleName = ModuleName.NEW_CHEST_SMALL;
        }else{
            moduleName = ModuleName.NEW_CHEST_BIG;
        }
        if (self.itemId == 31){
            // 现金没有飞入动画
            Toast.make(getText("new_chest_tip_getmoney"));
        }else{
            cc.log("dc GetRewardsPanel  isAd isShare ", self.params.isAd, self.params.isShare);
            if (self.params.isAd){
                UserProp.getInstance().rewardProp(self.itemId, self.itemNum, null, null, moduleName, {
                    category: "ad",
                    sub_category: "newchest_gacha"
                });
            }else if (self.params.isShare){
                UserProp.getInstance().rewardProp(self.itemId, self.itemNum, null, null, moduleName, {
                    category: "share",
                    sub_category: "newchest_gacha"
                });
            }else{
                UserProp.getInstance().rewardProp(self.itemId, self.itemNum, null, null, moduleName);
            }
            var pos = self.convertToWorldSpace(cc.p(self.coin.getPosition()));
            var flyItemOps = table();
            table.insert(flyItemOps, table(
                [1, "itemId", self.itemId],
                [1, "num", self.itemNum],
                [1, "pos", pos],
                [1, "scale", 0.5]
            ));
            HomeSceneAnimation.playGetPropAnimation(flyItemOps, null, 0.15);
        }
    }else{
        var pos = self.convertToWorldSpace(cc.p(self.coin.getPosition()));
        var flyItemOps = table();
        table.insert(flyItemOps, table(
            [1, "itemId", self.itemId],
            [1, "num", self.itemNum],
            [1, "pos", pos],
            [1, "scale", 0.5]
        ));
        HomeSceneAnimation.playGetPropAnimation(flyItemOps, null, 0.15);
    }
    if (self.continueCheckName == ContinueCheckName.kAdProp) {
        UserProp.getInstance().rewardProp(self.itemId, self.itemNum, null, null, ModuleName.AD_PROP);
    }else if (self.continueCheckName == ContinueCheckName.kAdGacha) {
        UserProp.getInstance().rewardProp(self.itemId, self.itemNum, null, null, ModuleName.AD_GACHA, {
            category: "ad",
            sub_category: "ad_gacha"
        });
    }else if (self.continueCheckName == ContinueCheckName.kGachaAccumulate) {
        UserProp.getInstance().rewardProp(self.itemId, self.itemNum, null, null, ModuleName.GACHA_ACCUMULATE);
    }
    self.onClose();
    if (self.params && self.params.closeCb){
        self.params.closeCb();
    }
    self.rewardsList.splice(0, 1);
    cc.log(self.rewardsList);
    if (self.rewardsList.length > 0){
        var showNext = function(){
            GetRewardsPanel.show(self.continueCheckName, self.rewardsList, false, null, self.getBySelf);
        }
        if (showNextInterval > 0){
            setTimeout(showNext, showNextInterval*1000);
        }else{
            showNext();
        }
    }else{
        self.finish = true;
        ContinueCheckManager.getInstance().resume();
    }
}

GetRewardsPanel.prototype.showOneReward = function(getBySelf){
    var self = this;
    var reward = self.rewardsList[0];
    var avatorNode = self.getChildByName("player").getChildByName("head portrait");
    avatorNode.x += 53;
    avatorNode.y -= 53;
    avatorNode.setAnchorPoint(cc.p(0.5, 0.5));
    if (getBySelf){
        // HeadImageLoader.loadImage(avatorNode, UserManager.getInstance().profile.headUrl);
        // self.getChildByName("player_name").setString(UserManager.getInstance().profile.name);
        self.getChildByName("player").setVisible(false);
        self.getChildByName("player_name").setVisible(false);
        var pos = self.getChildByName("player").getPosition();
        var titleString = "恭喜获得奖励";
        if (self.params && self.params.title){
            titleString = self.params.title;
        }
        var title = cc.LabelBMFont.create(titleString, "font/zzgftongxin_40_greenstroke.fnt");
        self.addChild(title);
        pos.x += 60;
        pos.y -= 115;
        title.setPosition(pos);
        title.setAnchorPoint(cc.p(0.5, 0.5));
        title.setScale(1.1);
    }else{
        HeadImageLoader.loadImage(avatorNode, reward.avatar);
        self.getChildByName("player_name").setString(HeDisplayUtil.urlDecode(reward.nick));
    }
    self.getChildByName("button_green_get").getChildByName("label").x += 20;

    var num = self.getChildByName("num")

    self.itemId = reward.itemId;
    self.itemNum = parseInt(reward.num);
    self.flyToPos = reward.pos; //不是飞到背包的需要这个飞到的位置
    self.mainPanelScoreTxtShowanim = reward.anim;
    var notCashCoin = false;
    if (getBySelf){
        if (self.itemId == 31){
            // 星星抽奖的现金红包
            self.coin = self.getChildByName("icon");
            var p = self.coin.getPosition();
            p.y -= 66;
            self.coin.removeFromParent();
            num.removeFromParent();
            var node = cc.Node.create();
            self.addChild(node);
            node.setPosition(p);
            var num2 = Math.floor(self.itemNum/10)/10;
            var txt1 = cc.LabelBMFont.create(num2, "font/zzgftongxin_40_yellow_brownstroke.fnt");
            node.addChild(txt1);
            txt1.setPosition(0, 0);
            txt1.setAnchorPoint(cc.p(0, 0));
            var txt2 = cc.LabelBMFont.create("元", "font/zzgftongxin_40_yellow_brownstroke.fnt");
            node.addChild(txt2);
            txt2.setPosition(txt1.width+10, 0);
            txt2.setAnchorPoint(cc.p(0, 0));
            node.setScale(1.2);
            num = txt1;
        }else{
            if (self.itemId > 10000){
                var icon = UIItemBuilder.createProp(self.itemId, null, 1)[0];
                var pos = self.getChildByName("icon").getPosition();
                self.getChildByName("icon").removeFromParent();
                self.addChild(icon);
                icon.setPosition(pos.x+40, pos.y-20);
                icon.setName("icon");
                self.coin = icon;
            }else{
                var FrameName = "properties/prop_"+ self.itemId +".png";
                self.coin = self.getChildByName("icon");
                if (self.itemId == 34){
                    // 34也是pvp的门票和10100用同一个
                    FrameName = "properties/prop_10100.png";
                }else{
                    if (self.itemId == 33){
                        self.coin.setScale(1.4);
                    }else{
                        self.coin.setScale(0.8);
                    }
                    self.coin.y += 12;
                }
                self.coin.setSpriteFrame(FrameName);
            }
            num.setString("x" + self.itemNum);
            num.x += 15;
            num.setNextFontPositionXOffset(-3);
        }
    }else{
        if (self.itemId == 14){
            self.getChildByName("silvercoin").setVisible(false);
            self.coin = self.getChildByName("goldcoin");
            self.coin.x += 20;
        } else if (self.itemId == 2){
            self.getChildByName("goldcoin").setVisible(false);
            self.coin = self.getChildByName("silvercoin");
            self.coin.x += 20;
        }
        self.coin.setScale(0.9);
        num.setString(self.itemNum);
    }

    if (getBySelf){
        num.setScale(1);
    }else{
        if (notCashCoin){
            num.x += 60;
            num.y -= 3;
        }else{
            num.x += 30;
            num.y -= 3;
        }
        num.setScale(0.6);
    }
    cc.log(num);

    var ok = self.getChildByName("button_green_get");
    var okBtn = UIButton.create(ok);
    okBtn.on(UIButtonEvent.Click, function () {
        self.okClick();
    })
    ButtonPushBounceAnim.create(okBtn);
    ButtonPushBounceIdleBubbleAnim.create(okBtn);

    if (getBySelf){
        
    }else{
        self.getChildByName("txt").setString(getText("get.happycoin.getreward.text"));
    }
    self.getChildByName("button_green_get").getChildByName("label").setString(getText("get.happycoin.getreward.button"));

    if (getBySelf){

    }else{
        if (self.continueCheckName == ContinueCheckName.kShareReward){
            DCAssist.dc4ClickShare("share", "lack_of_happycoins", {"type":self.itemNum});
        }
    }
}

GetRewardsPanel.prototype.popup = function () {
    var self = this
    var targetScale = self.getScale()
    self.setScale(0)
    var time = 7 / 30
    PopoutManager.getInstance().addWithBgFadeIn(self, true, false)
    var dH = display.height-GamePlayConfig_Design_Height;
    var targetPos = cc.pAdd(cc.p(self.getPosition()), cc.p(90, 850 + dH/2 - 100));
    var pos_O = cc.p(display.width / 2, display.height / 2)
    var startPoint = cc.pMul(cc.pSub(targetPos, pos_O), 0.23)
    self.setScale(0.23)
    self.setPosition(cc.p(pos_O.x + startPoint.x, pos_O.y + startPoint.y))
    self.runAction(cc.Sequence.create(cc.EaseSineOut.create(cc.Spawn.create(cc.ScaleTo.create(time, targetScale), cc.MoveTo.create(time, targetPos)))))
    return self
}

GetRewardsPanel.prototype.onCleanup = function(){
    var self = this
    if (self.finish){
        ResManager.release(["packed/CommonGetRewardPanelRes.pack"]);
    }
}

module.exports = GetRewardsPanel